module.exports = __webpack_public_path__ + "static/media/checkBox.55d3a86d.svg";